<div class="flyoutMenuWrapper">
    <div class="threeDotMenu" fxLayout="column" fxLayoutAlign="center center" (click)="onOpen()" [class.isOpen]="isOpen">
        <span class="circle"></span>
        <span class="circle"></span>
        <span class="circle"></span>
    </div>
    <div class="flyoutMenu" [class.isOpen]="isOpen">
        <div class="flyoutMenuOptions">
            <div *ngFor="let option of options" (click)="option.action(item, itemIndex)">
                <p>{{ option.name }}</p>
            </div>
        </div>
    </div>
    <div [class.isOpen]="isOpen" class="flyoutMenuOverlay" (click)="onOpen()"></div>
</div>
